export default __webpack_public_path__ + "static/media/Mapa-de-Medellin-Cifras_Convocatorias---movil-vertical.966818d7.jpg";